module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide-fade",
      "mode": "in-out"
    }
  }, [(_vm.getTranches.length || _vm.getTranchesPending) ? _c('div', {
    staticClass: "promotor-tranches"
  }, [_c('div', {
    staticClass: "headline"
  }, [_c('h2', {
    staticClass: "col s12 m6"
  }, [_vm._v("Historia wypłat")])]), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('table', {
    staticClass: "responsive-table highlight centered"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Nr transzy"), _c('span', {
    staticClass: "hide-on-med-and-down"
  }, [_c('br'), _vm._v("(tytuł faktury/rachunku)")])]), _vm._v(" "), _c('th', [_vm._v("Wartość")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Data utworzenia")]), _vm._v(" "), _c('th', [_vm._v("Zobacz"), _c('span', {
    staticClass: "hide-on-med-and-down"
  }, [_c('br'), _vm._v("szczegóły")])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.getTranches), function(trancheItem) {
    return _c('tr', {
      key: trancheItem.token
    }, [_c('td', [_vm._v(_vm._s(trancheItem.token))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("currency")(trancheItem.amount)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(trancheItem.changes[0].status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("date")(trancheItem.created_at)))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          return _vm.openModal(trancheItem)
        }
      }
    }, [_c('i', {
      staticClass: "mfind-icon-search"
    })])])])
  }), 0)]), _vm._v(" "), (_vm.showModal) ? _c('modal-tranche-history', {
    attrs: {
      "tranche": _vm.tranche,
      "showModal": _vm.showModal
    },
    on: {
      "close": function($event) {
        _vm.showModal = !_vm.showModal
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('Loader', {
    attrs: {
      "loading": _vm.getTranchesPending,
      "type": ""
    }
  })], 1)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37d7eca7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/promotorTranches.vue
// module id = 371
// module chunks = 0